(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // BETTINO 2026-09-11: the mobile Sort pill (.bt-sort-pill__select) drives the
  // filter drawer's sort select, so the drawer form (which carries the active
  // filters) submits the change. Delegated at document level because the pill
  // is re-rendered with the section on every filter or sort update.
  document.addEventListener('change', (event) => {
    const pill = event.target;
    if (!(pill instanceof HTMLSelectElement) || !pill.classList.contains('bt-sort-pill__select')) return;
    const drawerSelect = document.querySelector('#filters-drawer select[name="sort_by"]');
    if (!(drawerSelect instanceof HTMLSelectElement)) return;
    drawerSelect.value = pill.value;
    drawerSelect.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

})();
